import { Card } from "@design-system/Card/Card";
import { getEnv } from "@lib/environment";

import { Button } from "@design-system/Button/Button";
import { BillingInfo } from "@common/types/billing";
import classNames from "classnames";
import { capitalize } from "@common/helpers/string";
import { getAnonymousAccountNumber } from "@common/helpers/bankAccount";
import styles from "./FlatRateBilling.module.scss";

interface BillingInfoCardProps {
    billingInfo: BillingInfo;
    editable?: boolean;
}

export const BillingInfoCard: React.FC<BillingInfoCardProps> = ({
    billingInfo,
    editable = false,
}) => {
    let billedTo: React.ReactNode;

    if (billingInfo?.address || billingInfo?.name) {
        const addressLine = [
            billingInfo.name,
            billingInfo.address?.street,
            billingInfo.address?.country,
        ]
            .filter(Boolean)
            .join(", ");

        billedTo = (
            <section className={classNames(styles.section, styles.compact)}>
                <main>
                    <div>
                        <header className={styles.title}>Billed to</header>
                        {addressLine}
                    </div>
                    <aside>
                        {editable && (
                            <Button variant="primary" size="md" asChild>
                                <a
                                    href={getEnv("VITE_STRIPE_PORTAL_URL")}
                                    target="_blank"
                                    className="text-decoration-none"
                                >
                                    Edit address
                                </a>
                            </Button>
                        )}
                    </aside>
                </main>
            </section>
        );
    }

    return (
        <Card className={styles.card}>
            {billingInfo?.paymentMethod && (
                <section className={classNames(styles.section, styles.compact)}>
                    <main>
                        <div>
                            <header className={styles.title}>
                                Payment method
                            </header>
                            {capitalize(
                                billingInfo.paymentMethod.brand.toLowerCase(),
                            )}{" "}
                            {getAnonymousAccountNumber(
                                billingInfo.paymentMethod.last4,
                                2,
                                "",
                            )}
                        </div>
                        <aside>
                            {editable && (
                                <Button variant="primary" size="md" asChild>
                                    <a
                                        href={getEnv("VITE_STRIPE_PORTAL_URL")}
                                        target="_blank"
                                        className="text-decoration-none"
                                    >
                                        Change method
                                    </a>
                                </Button>
                            )}
                        </aside>
                    </main>
                </section>
            )}
            {billingInfo?.email && (
                <section className={classNames(styles.section, styles.compact)}>
                    <main>
                        <div>
                            <header className={styles.title}>
                                Billing email
                            </header>
                            {billingInfo.email}
                        </div>
                        <aside>
                            {editable && (
                                <Button variant="primary" size="md" asChild>
                                    <a
                                        href={getEnv("VITE_STRIPE_PORTAL_URL")}
                                        target="_blank"
                                        className="text-decoration-none"
                                    >
                                        Update email
                                    </a>
                                </Button>
                            )}
                        </aside>
                    </main>
                </section>
            )}

            {billedTo}
        </Card>
    );
};
